import React from "react";
import AttachmentContent from "./attachment-content.jsx";
import DatesContent from "./dates-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const CreateContent = ({element}) => {
    const createData = JSON.parse(element?.new ?? "{}");

    return (
        <tr className="create-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className="text-left">
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "70%"}}>Novo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.entries(createData).map(([key, value], index) => {

                            if (key === "attachment") {
                                const attachments = Array.isArray(value) ? value : Object.values(value);

                                return (
                                    <AttachmentContent key={index} attachments={attachments}/>
                                );
                            }

                            if (key === "dates") {
                                return (
                                    <DatesContent key={index} dates={value}/>
                                );
                            }

                            return (
                                <tr key={index} className="text-left">
                                    <td>{key}</td>
                                    <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default CreateContent;